import { Button } from '../Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../Dialog';
import { DocViewerComponent } from '../DocViewer';
import { Icons } from '../Icons';

const PreviewDownloadDialog = ({
  isOpen,
  onClose,
  previewFile,
}: {
  isOpen: boolean;
  onClose: () => void;
  previewFile: {
    fileName: string;
    signedURL: string;
  };
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex flex-col gap-4 max-w-[600px]">
        <DialogHeader className="flex flex-col items-start gap-4">
          <div className="flex flex-col gap-1">
            <DialogTitle>{previewFile?.fileName || 'Preview file'}</DialogTitle>
          </div>
        </DialogHeader>

        <div className="h-[400px] overflow-y-auto p-6">
          {previewFile?.signedURL && (
            <DocViewerComponent uri={previewFile.signedURL} />
          )}
        </div>

        <DialogFooter>
          <div className="flex justify-end w-full gap-2">
            <Button variant="secondary" onClick={window.print} size="sm">
              <Icons.Printer className="size-4" />
              Print
            </Button>
            <Button
              variant="primary"
              onClick={() => window.open(previewFile?.signedURL, '_blank')}
              size="sm"
            >
              <Icons.Download01 className="size-4" />
              Download
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { PreviewDownloadDialog };
